import { NgClass } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  input,
} from '@angular/core';
import { NgbAccordionCollapse, NgbAccordionDirective, NgbAccordionItem, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';

import { Faq } from '../../models/dot-cms-uve-contentlet.model';
import { filterEmaDotcmsPageLinks, onClickEmaDotcmsPageLinks } from '../../utils/dot-cms-uve-utils';

@Component({
  selector: 'custom-dot-cms-uve-faq',
  templateUrl: './dot-cms-uve-faq.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbAccordionDirective, NgbAccordionCollapse, NgbAccordionItem, NgbModule, NgClass, ServerHtmlDirective],
})
export class DotCmsUveFaqComponent implements OnInit, AfterViewChecked {
  contentlet = input.required<Faq>();
  lastPanelId: string;
  panelId: string;

  constructor(private renderer: Renderer2, private el: ElementRef) {}

  ngOnInit() {
    onClickEmaDotcmsPageLinks(this.el, this.renderer);
    this.panelId = `panel-${this.contentlet().identifier}`;
  }
  ngAfterViewChecked() {
    filterEmaDotcmsPageLinks(this.el, this.renderer);
  }
  isOpened(item: NgbAccordionItem) {
    //@ts-ignore
    return item._collapsed;
  }
}
